<template>
  <div>
    <job-edit-drop-off
      :is-edit-drop-off-sidebar-active.sync="isEditDropOffSidebarActive"
      :drop-off-data="viewDropOffData"
      :job-id="jobId"
      @updateDropOff="jobViewDropOffUpdate"
      @updateJobCanSchedule="handleUpdateJobCanSchedule"
    />
    <b-card
      no-body
    >
      <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
        <h5 class="mb-0">
          Drop off
        </h5>
      </b-card-header>

      <b-card-body v-if="!viewDropOffData">
        No drop off checkpoint added.
        <b-row class="px-1 pt-2 d-flex justify-content-end">
          <b-button
            variant="outline-primary"
            @click="isEditDropOffSidebarActive = true"
          >
            <span class="text-nowrap">Add Drop Off</span>
          </b-button>
        </b-row>
      </b-card-body>
      <b-card-body v-else>
        <ul
          v-if="viewDropOffData"
          class="list-unstyled my-1"
        >
          <li>
            <span class="align-middle">Name: {{ viewDropOffData.name ? viewDropOffData.name : 'Not set' }}</span>
          </li>
          <li>
            <span class="align-middle">Address: {{ viewDropOffData.address }}</span>
          </li>
          <li class="my-25">
            <span class="align-middle">Phone number: {{ viewDropOffData.phoneNumber ? viewDropOffData.phoneNumber : 'N/A' }}</span>
          </li>
        </ul>
        <b-row
          align-h="end"
          class="mx-auto justify-content-between"
        >
          <b-button
            v-if="isEditable"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            @click="isEditDropOffSidebarActive = true"
          >
            <feather-icon
              icon="Edit2Icon"
              class="mr-50"
            />
            <span>Edit</span>
          </b-button>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BButton, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import JobEditDropOff from '@/views/job/jobs-edit/JobEditDropOff.vue'
import checkpointStoreModule from '@/views/checkpoint/checkpointStoreModule'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BRow,
    JobEditDropOff,
  },
  props: {
    dropOffData: {
      type: Object,
      required: false,
      default: null,
    },
    jobId: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      viewDropOffData: this.$props.dropOffData,
    }
  },
  methods: {
    jobViewDropOffUpdate(data) {
      this.viewDropOffData = data
    },
    handleUpdateJobCanSchedule(data) {
      this.$emit('updateJobCanSchedule', data)
    },
  },
  setup() {
    const CHECKPOINT_APP_STORE_MODULE_NAME = 'app-checkpoint'
    // Register module
    if (!store.hasModule(CHECKPOINT_APP_STORE_MODULE_NAME)) store.registerModule(CHECKPOINT_APP_STORE_MODULE_NAME, checkpointStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHECKPOINT_APP_STORE_MODULE_NAME)) store.unregisterModule(CHECKPOINT_APP_STORE_MODULE_NAME)
    })

    const isEditDropOffSidebarActive = ref(false)
    return {
      isEditDropOffSidebarActive,
    }
  },
}
</script>

<style>

</style>
